export const contentTemplates = {};

export const profileTemplates = {};

export const taxonomyTemplates = [];

export const SAMPLE_TEMPLATES = {
  ...contentTemplates,
  ...profileTemplates,
};

export const ALL_TEMPLATES = [
  ...Object.values(contentTemplates),
  ...Object.values(profileTemplates),
  ...taxonomyTemplates,
];

export const TEST_CASES = [];
